import SlCheckMdl from '@/models/Sale/SlCheck'
import moment from 'moment'
const getChecks = async function(payload) {
    const includesParams = [
        'g_bank',
        'pos_payment_check_type',
        'sl_check_status',
        'pos_cash_desk.g_branch_office',
        'g_cashier_user.hr_employee',
        
    ]

    try {
        let response = await SlCheckMdl
            .include(includesParams)
            .params({ get_all_results: true })
            .where('pos_cash_desk_id', payload.pos_cash_desk_id)
            .where('g_cashier_user_id', payload.g_cashier_user_id)
            .where('emission_date_min',moment().format('YYYY-MM-DD'))
            .where('emission_date_max',moment().format('YYYY-MM-DD'))
            .where('non_retired', true)
            .get()
        return response
    } catch (error) {
        console.log('ERROR')
        console.log(error.response)
        return error.response.data
    }
}

const retireCheck = function(idCheck){
    let checkMdl = new SlCheckMdl()
    return checkMdl.retireCheck(idCheck)
}

export default { getChecks, retireCheck }
